// extracted by mini-css-extract-plugin
export default {"micrositeContainer":"micrositeContainer--1axhp","headerContainer":"headerContainer--m-6SG","feedbackSection":"feedbackSection--2qhQe"};